import CircleIconFlag from "../../../ui/CircleIconFlag";

import { IconWrapper } from "../../../ui/SelectAndSearch/SelectAndSearch.styled";
import { Button, Item, List } from "./LanguageList.styled";

export const LanguagesList = ({ arrLang, changeLanguage }) => (
  <List>
    {!!arrLang.length &&
      arrLang.map(({ id, code, originalName }) => (
        <Item key={id}>
          <Button
            type="button"
            onClick={changeLanguage(code)}
            aria-label={code}
          >
            <IconWrapper>
              <CircleIconFlag className={code} />
            </IconWrapper>
            {originalName}
          </Button>
        </Item>
      ))}
  </List>
);
